import React from 'react';
import { useAssetInformationSelection } from './useAssetInformationSelection';

declare var InovxLoader: any;

interface AssetInformationButtonProps {
    isExpanded: boolean;
    onShowAssetInformation: () => void;
}

const AssetInformationButton: React.FC<AssetInformationButtonProps> = ({ isExpanded, onShowAssetInformation }) => {
    const isAssetSelected = useAssetInformationSelection();

    return (
        <button
            id="asset-info-button"
            type="button"
            title={InovxLoader.t(isExpanded ? 'facility:viewer.hideAssetInformation' : 'facility:viewer.showAssetInformation')}
            onClick={() => isAssetSelected && onShowAssetInformation()}
        >
            <span className={`content-layer-icons speeddial-icon-asset-info ${!isAssetSelected ? 'incactive-icon' : ''}`}></span>
        </button>
    );
};

export default AssetInformationButton;
